import styled from "styled-components";
import { color } from "../../styles";
import { Button } from "@mui/material";

export const SearchFilterBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
  padding: 0;
  margin-bottom: 8px;
  min-height: 34px;
  border-radius: 5px;
`;

export const FilterSortWrapper = styled.div`
  display: flex;
  gap: 8px;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  flex-wrap: wrap;
`;

interface BoxWrapperProps {
  isClicked?: boolean;
}

export const BoxWrapper = styled.div<BoxWrapperProps>`
  display: flex;
  gap: 8px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid ${color.emphasis.NEUTRAL_N30};
  height: 34px;
  align-items: center;
  border-radius: 5px;
  box-sizing: border-box;

  background-color: ${(props: BoxWrapperProps) =>
    props.isClicked && color.primary.BLUE_B100};

  color: ${(props: BoxWrapperProps) => props.isClicked && "white"};

  &:hover {
    cursor: pointer;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1;
`;

export const RefreshButton = styled(Button)`
  && {
    font-size: 0.75rem;
    padding: 2px 6px;
    border-color: #1976d2;
    color: #1976d2;
    border-radius: 5px;
    height: 34px;
    min-width: auto;
    
    &:hover {
      border-color: #1565c0;
      background-color: rgba(25, 118, 210, 0.04);
    }
  }
`;

export const ClearFilterButton = styled(Button)`
  && {
    font-size: 0.75rem;
    padding: 2px 6px;
    border-color: #d32f2f;
    color: #d32f2f;
    border-radius: 5px;
    height: 34px;
    min-width: auto;
    
    &:hover {
      border-color: #c62828;
      background-color: rgba(211, 47, 47, 0.04);
    }
  }
`;